var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup47599(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1135.211,
    height: 959.996,
    viewBox: "0 0 1135.211 959.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53b1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47599",
    "data-name": "Group 47599",
    transform: "translate(-514.789 -1138.79)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37128",
    "data-name": "Path 37128",
    d: "M974.7,1337.6c-249.349,100.663-114.1,347.3-367.668,414.923C472.5,1788.4,426.794,1856.784,413.525,1913.09H1548.736v-960H1161.961C1166.947,1083.149,1139.157,1271.2,974.7,1337.6Z",
    transform: "translate(101.264 185.695)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37129",
    "data-name": "Path 37129",
    d: "M672.131,1913.09c4.055-56.306,38.57-124.7,167.233-160.571,242.5-67.618,16.368-314.26,249.249-414.923,153.6-66.4,97.193-254.447,70.931-384.5h-.1c4.983,130.054-22.8,318.106-187.269,384.5-249.349,100.663-114.1,347.3-367.665,414.923-134.532,35.876-180.237,104.265-193.5,160.571H672.131Z",
    transform: "translate(103.779 185.695)",
    fill: "#fff",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47599);
export default __webpack_public_path__ + "static/media/Group 47599.28167fad131f33d976dc1345d4df73dc.svg";
export { ForwardRef as ReactComponent };